var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebsocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2500,
  height: 1885,
  viewBox: "0 0 256 193",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#dd4923",
  d: "M192.44 144.645h31.78V68.339l-35.805-35.804-22.472 22.472 26.497 26.497v63.14zm31.864 15.931H113.452L86.954 134.08l11.237-11.236 21.885 21.885h45.028l-44.357-44.441 11.32-11.32 44.357 44.358v-45.03l-21.801-21.801 11.152-11.153L110.685 0H0l31.696 31.696v.084h65.74l23.227 23.227-33.96 33.96L63.476 65.74V47.712h-31.78v31.193l55.007 55.007L64.314 156.3l35.805 35.805H256l-31.696-31.529z"
})));
export { SvgWebsocket as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/websocket.svg";